module.exports = __webpack_public_path__ + "img/zen.ae803538.svg";